import { z } from "zod";

import { auditDate } from "@/schemas";

import { environmentalChecklistItemWithTicket } from "../../../../schemas";

export const moveInMoveOutMiscSchema = z.object({
  locationId: z.string().min(1, "Required"),
  auditDate: auditDate,
  reviewerId: z.string().min(1, "Required"),
  miscScreen: environmentalChecklistItemWithTicket,
  miscStair: environmentalChecklistItemWithTicket,
  miscPorch: environmentalChecklistItemWithTicket,
  miscDrape: environmentalChecklistItemWithTicket,
});
